import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { css } from 'aphrodite/no-important';
import styles from './AccordionMenu.styles';
import SvgIcon from '../../common/svgicon/SvgIcon';

class AccordionMenu extends Component {
  state = { isMenuOpen: false };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  toggle = () => {
    if (!this.state.isMenuOpen) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
    document.removeEventListener('click', this.handleOutsideClick, false);
  };

  handleClick = option => {
    if (this.props.handleClick) {
      this.props.handleClick(option);
    }
    this.close();
  };

  handleOutsideClick = e => {
    let node = ReactDOM.findDOMNode(this);
    if (e.target instanceof Node && node && !node.contains(e.target)) {
      this.close();
    }
  };

  renderList = () => {
    let { options,styles: customStyles } = this.props;
    let { isMenuOpen } = this.state;
    return (
      <ul className={`${css(styles.ul, isMenuOpen && styles.ulshow)}`}>
        <div className={css(styles.items,customStyles)}>
          {options &&
            options.map((option, i) => (
              <li
                className={css(styles.li)}
                onClick={() => this.handleClick(option.value)}
                key={i}
              >
                {option.text}
              </li>
            ))}
        </div>
      </ul>
    );
  };

  render() {
    const { styles: customStyles } = this.props;
    return (
      <div className={css(styles.base, customStyles)}>
        <div className={css(styles.menu)}>
          <SvgIcon value="dots" styles={styles.icon} onClick={this.toggle} />
          {this.renderList()}
        </div>
      </div>
    );
  }
}

export default AccordionMenu;



// WEBPACK FOOTER //
// ./src/components/data/accordionmenu/AccordionMenu.js